import type { ActivationGroup } from '@/features/activationGroup/types'
import PriceDataGrid from '@/features/bidding/components/price/offer/PriceDataGrid'
import type { GroupedBidParams } from '@/features/bidding/utils/groupedBidParams/buildBiddingLinks'
import type { AggregatedBid } from '@/features/bidding/utils/model/buildAggregatedBid'
import type { AggregatedBidWrapper } from '@/features/bidding/utils/model/mapActivationGroupBidsToAggregatedBids'
import { validateAggregatedBid } from '@/features/bidding/utils/validation/aggregatedBidValidations'

type Props = {
  activationGroup: ActivationGroup
  bidsPerActivationGroup: Map<string, AggregatedBidWrapper>
  groupParams: GroupedBidParams
  hasAlreadyBidsForTheDay?: boolean
  onBidForActivationGroupUpdated: (updatedBid: AggregatedBidWrapper) => void
}

const PriceDataGridForActivationGroup = ({
  activationGroup,
  bidsPerActivationGroup,
  groupParams,
  hasAlreadyBidsForTheDay = false,
  onBidForActivationGroupUpdated,
}: Props) => {
  const setAggregatedBid = (newAggregatedBid: AggregatedBid) => {
    onBidForActivationGroupUpdated({
      activationGroup: activationGroup,
      aggregatedBid: newAggregatedBid,
      state: validateAggregatedBid(newAggregatedBid, activationGroup, bidsPerActivationGroup, groupParams.bidType),
    })
  }

  const aggregatedBid = bidsPerActivationGroup.get(activationGroup.uuid)!.aggregatedBid

  return (
    <>
      {aggregatedBid.ptus.length > 0 && (
        <PriceDataGrid
          activationGroupUuids={[activationGroup.uuid]}
          aggregatedBid={aggregatedBid}
          bidsPerActivationGroup={bidsPerActivationGroup}
          groupParams={groupParams}
          hasAlreadyBidsForTheDay={hasAlreadyBidsForTheDay}
          isLoading={false}
          onAggregatedBidChange={setAggregatedBid}
        />
      )}
    </>
  )
}

export default PriceDataGridForActivationGroup
